import { DEFAULT_STATE } from '@/constants'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
    uploadedImage: {
      file: null,
      url: '',
      name: '',
      loading: false,
      error: '',
    },
    imageUpload: {
      loading: false,
      error: '',
      progress: 0,
      result: null,
    },
    imagePrompt: {
      loading: false,
      error: '',
      result: null,
      prompt: '',
    },
    videoGeneration: {
      loading: false,
      error: '',
      result: null,
      taskId: null,
    },
    videoPolling: {
      loading: false,
      error: '',
      result: null,
      status: null,
      videoUrl: null,
      pollingInterval: null,
    },
    selectedVideos: [],
    formVideoGeneration: {
      loading: false,
      error: '',
      result: null,
    },
    videoSourceUpload: {
      loading: false,
      error: '',
      progress: 0,
      result: null,
    },
    videoList: {
      videos: [],
      loading: false,
      error: null,
      pagination: {
        page: 1,
        limit: 15,
        total: 0,
        totalPages: 0,
      },
      projectId: '68c8c230d3c3ea297e4cceda',
    },
    aiAnalyze: {
      loading: false,
      error: '',
      result: null,
    },
    promptSuggestions: {
      data: {},
      loading: false,
      error: null,
    },
    imageGeneration: {
      loading: false,
      error: null,
      result: null,
      taskId: null,
      status: null,
      generatedImageUrl: null,
      generatedImagePromptText: null,
    },
    imageGenerationPolling: {
      loading: false,
      error: null,
      status: null,
      result: null,
      pollingInterval: null,
    },
    // Overall image generation process state
    imageGenerationProcess: {
      loading: false,
    },
  },
  getters,
  mutations,
  actions,
}
